import React, { useContext, useMemo } from 'react';
import { shallowEqual, useSelector } from 'umi';
import { FilterContext } from "@/pages/dashboard/components/PageContainer/context";
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { formatFilterValues, otherParamsVal } from '@/pages/dashboard/utils/utils';
import { IApiParamsBase, IApiParamsWithKey } from './type';
import { PERIODTIMEOBJ } from '@/pages/dashboard/_config/constant';

export default function SalesOverviewService(props: any) {
  const { style, className, config, children, data: propsData, serviceType, ...resetProps } = props || {};
  const { api, dataKey, refreshKey = '', interval, metric = '', otherParams: otherParamsData } = config || {};
  const { filterVal } = useContext(FilterContext);
  const { gameCode } = useSelector((state: any) => ({
    gameCode: state?.dashboard?.currentGame?.game_code
  }), shallowEqual);

  const data = useMemo(() => ({
    ...(propsData || {}),
    gameCode,
    metric,
  }), [gameCode, metric, propsData]);

  return (
    <div className={className} style={style}>
      <Service
        api={api}
        data={data}
        dataKey={dataKey}
        refreshKey={refreshKey}
        interval={interval}
        beforeRequest={(data) => {
          const { filterVal, gameCode, metric, by_tab, ...restData } = data;
          const { rangeTime, diff, newFilter, selector, timeType, ...filters } = filterVal || {};
          const filtersVal = formatFilterValues(filters);
          const otherParams = otherParamsVal(otherParamsData, filtersVal) || {};

          // 传参兜底筛选器参数
          const params: IApiParamsBase | IApiParamsWithKey = {
            game_code: gameCode,
            filters: filtersVal,
            start_time: rangeTime[0],
            end_time: rangeTime[1],
            period: PERIODTIMEOBJ[timeType],
            timeType,
            ...(restData || {}),
            ...(otherParams || {})
          };
          if (metric) {
            params.metric = metric;
          }
          return params;
        }}
        trackData={['gameCode', 'by_type', 'by_tab', 'metric']}
      >
        {React.Children.map(children, (child: any) => React.cloneElement(
          child,
          {
            filterVal,
            ...resetProps
          }
        ))}
      </Service>
    </div>
  );
};